import React from 'react';
import Tab from 'react-bootstrap/Tab'
import Nav from 'react-bootstrap/Nav'
import Table from 'react-bootstrap/Table'
import MetricFormatter from 'dashboards/MetricFormatter'
import PPCSummaryOverall from 'dashboards/PPCSummaryOverall'
import PPCSummarySearch from 'dashboards/PPCSummarySearch'
import PPCSummarySocial from 'dashboards/PPCSummarySocial'
import PPCSummaryDisplay from 'dashboards/PPCSummaryDisplay'
import PPCSummaryVideo from 'dashboards/PPCSummaryVideo'

class PPCSummary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabLocation: ""
    }
  }

  changeSection(hashLoc = "overall") {
    let exportButton = $('.ppc-summary-export-pdf');
    let href = exportButton.attr("href").split("&section=")[0];
    exportButton.attr("href", href + "&section=" + hashLoc);
  }

  componentDidMount() {
    let hashLoc = location.hash.replace("#", "");
    if (hashLoc != "") {
      this.setState({tabLocation: hashLoc})
      this.changeSection(hashLoc);
    } else {
      location.hash = "#overall"
      this.setState({tabLocation: "overall"})
      this.changeSection();
    }
  }

  selectTab(key)
  {
    location.hash = "#" + key
    this.setState({tabLocation: key})
    this.changeSection(key);
  }

  render() {
    return (
      <Tab.Container className="" id="ppc-summary-tabs" defaultActiveKey="overall" activeKey={this.state.tabLocation} onSelect={(k) => this.selectTab(k)}>
        <Nav variant="pills" className="nav-fill tabs-navigation row no-gutters row-cols-sm-1 row-cols-md-5">
            <Nav.Item className="col">
              <Nav.Link eventKey="overall">Overall</Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="paidSearch">Paid Search</Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="paidSocial">Paid Social</Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="displayAds">Display Ads</Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="videoAds">Video Ads</Nav.Link>
            </Nav.Item>
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="overall">
            <PPCSummaryOverall client_list={this.props.client_list} metric_list={this.props.metric_list} metrics={this.props.overall_metrics}/>
          </Tab.Pane>
          <Tab.Pane eventKey="paidSearch">
            <PPCSummarySearch client_list={this.props.client_list} metric_list={this.props.metric_list} metrics={this.props.search_metrics}/>
          </Tab.Pane>
          <Tab.Pane eventKey="paidSocial">
            <PPCSummarySocial client_list={this.props.client_list} metric_list={this.props.metric_list} metrics={this.props.social_metrics}/>
          </Tab.Pane>
          <Tab.Pane eventKey="displayAds">
            <PPCSummaryDisplay client_list={this.props.client_list} metric_list={this.props.metric_list} metrics={this.props.display_metrics}/>
          </Tab.Pane>
          <Tab.Pane eventKey="videoAds">
            <PPCSummaryVideo client_list={this.props.client_list} metric_list={this.props.metric_list} metrics={this.props.video_metrics}/>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    )
  }
}

export default PPCSummary;
